/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { UserListFilterDto, UserListItemDto } from '@gh/builder-shared-data';

export type UserFinderFilter = UserListFilterDto;
export type UserFinderListItem = UserListItemDto;

export const getUserFinderListItemId = (user: UserFinderListItem) => user.userId;
